import React from 'react';
import { Trans } from '@lingui/react';
import { isMobileOnly, isIOS } from 'react-device-detect';
import { Link } from 'react-router-dom';
import vieweet from '../../../../images/vieweet-logo/vieweet-logo.svg';
import x from '../../../../images/vieweet-logo/x.svg';

interface IProps {
  logoUrl: string;
}

const googleDeepLink =
  'https://play.google.com/store/apps/details?id=com.vieweet.app&gl=GB&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
const appleDeepLink = 'https://apps.apple.com/gb/app/vieweet-360/id837173911';

const UserAlreadyExists: React.FC<IProps> = ({ logoUrl }) => {
  const getAppLink = () => {
    if (isIOS) {
      return appleDeepLink;
    } else {
      return googleDeepLink;
    }
  };

  if (isMobileOnly) {
    return (
      <div className='initial-pages-bg'>
        <div className='onboarding-content-layout'>
          <div className='sign-up-partners-logo'>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={vieweet} alt='vieweet' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={x} alt='x' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={logoUrl} alt='x' />
            </div>
          </div>
          <div
            className='activate-account-initial-pages-container'
            style={{ padding: '40px 20px', width: '85%', height: '75%', transform: 'translate(-50%, -40%)' }}
          >
            <div className='activate-account-container-mobile'>
              <div data-testid='not-activated-text' className='title-activate-account-mobile'>
                <Trans id='Account Already Exists' />
              </div>
              <div className='message-partner'>
                <div className='sub-text-activate-account' style={{ color: '#000' }}>
                  It looks like you already have a Vieweet account.
                </div>
                <div className='sub-text-activate-account' style={{ color: '#000' }}>
                  Click the button below to open the Vieweet App and log in.
                </div>
              </div>
              <a href={getAppLink()} style={{ textDecoration: 'none' }}>
                <div className='a-ac-btn-container-link-partner button-hover'>Open the Vieweet App</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className='initial-pages-bg'>
        <div className='onboarding-content-layout'>
          <div className='sign-up-partners-logo'>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={vieweet} alt='vieweet' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={x} alt='x' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={logoUrl} alt='x' />
            </div>
          </div>
          <div />
          <div className='activate-account-initial-pages-container-partner'>
            <div className='activate-account-container-partner'>
              <React.Fragment>
                <div data-testid='not-activated-text' className='title-activate-account-partner'>
                  <Trans id='Account Already Exists' />
                </div>
                <div className='message-partner'>
                  <div className='sub-text-activate-account' style={{ color: '#000' }}>
                    It looks like you already have a Vieweet account.
                  </div>
                  <div className='sub-text-activate-account' style={{ color: '#000' }}>
                    Click the button below to go to the login page.
                  </div>
                </div>
                <Link to='/login'>
                  <div className='a-ac-btn-container-link-partner button-hover'>
                    <Trans id='Go to login page' />
                  </div>
                </Link>
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default UserAlreadyExists;
